import styled from "@emotion/styled";
import { COLOR_PRIMARY_MAIN, COLOR_WHITE } from "shared/theme/colors";
import FlexCenter from "../Layout/components/FlexCenter";

export const StyledIndicator = styled(FlexCenter, {
  shouldForwardProp: (propName) =>
    !["isSmallIndicator", "height", "width"].includes(propName),
})<{
  isSmallIndicator?: boolean;
  height?: string;
  width?: string;
}>`
  align-items: center;
  justify-content: center;
  color: ${COLOR_WHITE};
  font-size: 12px;
  font-weight: 700;
  height: ${({ isSmallIndicator, height }) =>
    height || (isSmallIndicator ? "1rem" : "1.5rem")};
  width: ${({ isSmallIndicator, width }) =>
    width || (isSmallIndicator ? "1rem" : "1.5rem")};
  border-radius: 50%;
  background-color: ${COLOR_PRIMARY_MAIN};
  font-size: ${({ isSmallIndicator }) => (isSmallIndicator ? "8px" : "12px")};
`;
